let cachedBundles = {};
let cachedPreloads = {};
let cachedPrefetches = {};

function getCache(type) {
  switch (type) {
    case 'preload':
      return cachedPreloads;
    case 'prefetch':
      return cachedPrefetches;
    default:
      return cachedBundles;
  }
}

module.exports = function cacheLoader(loader, type) {
  return function (bundle) {
    let cache = getCache(type);

    if (cache[bundle]) {
      return cache[bundle];
    }

    return (cache[bundle] = loader.apply(null, arguments).catch(function (e) {
      delete cache[bundle];
      throw e;
    }));
  };
};
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="5e280e42-933b-5681-95de-820266d7393b")}catch(e){}}();
//# debugId=5e280e42-933b-5681-95de-820266d7393b
